import { Box, Typography, Button, Modal, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Select, MenuItem, FormControl, InputLabel, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Toast } from 'primereact/toast';
import { useRef } from "react";
import { Calendar } from 'primereact/calendar';
import dayjs from "dayjs";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomAxios from "../../utils/CustomAxios";
import { useGetInventory } from "../globalFunctions";
import { useSelector } from "react-redux";
import { Dropdown } from 'primereact/dropdown';

export function BusinessOperationHistory() {
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState([today, today]);
    const [historyRecords, setHistoryRecords] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const selectedHub = useSelector(state => state.user.selected_hub);
    const [formData, setFormData] = useState({
        business_category_id: '',
        hub_id: selectedHub,
        total_amount: '',
        transaction_type: 'daily',
        transaction_date: ''
    });
    const [selectedId, setSelectedId] = useState(null);
    const toast = useRef(null);
    const getInventory = useGetInventory();
    const inventory = useSelector(state => state.inventory.inventory);
    const user_role = localStorage.getItem('role');

    useEffect(() => {
        fetchCategories();
        getInventory();
        fetchHistory();
    }, []);

    useEffect(() => {
        // Build inventory options: show all hubs but disable unassigned for restricted roles
        console.log(inventory);
        const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
        const filtered = inventory.map((inv) => {
            const isAssigned = assignedHubs.includes(inv.value);
            return {
                ...inv,
                name: inv.name,
            };
        });
        console.log(filtered);
        setFilteredInventory(filtered);
    }, [inventory, user_role]);


    useEffect(() => {
        fetchHistory();
    }, [selectedDate, selectedHub]);

    const fetchCategories = async () => {
        try {
            const response = await CustomAxios.get('business-operations-categories/');
            setCategories(response.data.filter(cat => cat.is_active));
        } catch (error) {
            showToast('error', 'Error', 'Failed to fetch categories');
        }
    };

    const fetchHistory = async () => {
        if (!Array.isArray(selectedDate) || !selectedDate[0]) return;

        const startDate = dayjs(selectedDate[0]).format('YYYY-MM-DD');
        const endDate = selectedDate[1]
            ? dayjs(selectedDate[1]).format('YYYY-MM-DD')
            : startDate;

        try {
            setLoading(true);
            const res = await CustomAxios.get(
                'business-operations-history/',
                { params: { start_date: startDate, end_date: endDate, hub_id:selectedHub[0] } }
            );
            setHistoryRecords(res.data);
        } catch {
            showToast('error', 'Error', 'Failed to fetch history records');
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (item = null) => {
        if (item) {
            setEditMode(true);
            setSelectedId(item.id);
            // Format date based on transaction type
            let formattedDate = item.transaction_date;
            if (item.transaction_type === 'monthly' && formattedDate) {
                // Extract year-month from date (YYYY-MM-DD -> YYYY-MM)
                formattedDate = formattedDate.substring(0, 7);
            }
            setFormData({
                business_category_id: item.business_category,
                hub_id: item.hub,
                total_amount: item.total_amount,
                transaction_type: item.transaction_type,
                transaction_date: formattedDate
            });
        } else {
            setEditMode(false);
            setSelectedId(null);
            setFormData({
                business_category_id: '',
                hub_id: '',
                total_amount: '',
                transaction_type: 'daily',
                transaction_date: new Date().toISOString().split('T')[0]
            });
        }
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setEditMode(false);
        setSelectedId(null);
        setFormData({
            business_category_id: '',
            hub_id: '',
            total_amount: '',
            transaction_type: 'daily',
            transaction_date: ''
        });
    };

    const handleSubmit = async () => {
        if (!formData.business_category_id) {
            showToast('error', 'Validation Error', 'Business category is required');
            return;
        }
        if (!formData.hub_id) {
            showToast('error', 'Validation Error', 'Hub is required');
            return;
        }
        if (!formData.total_amount || parseFloat(formData.total_amount) < 0) {
            showToast('error', 'Validation Error', 'Valid total amount is required');
            return;
        }
        if (!formData.transaction_date) {
            showToast('error', 'Validation Error', formData.transaction_type === 'monthly' ? 'Transaction month is required' : 'Transaction date is required');
            return;
        }

        try {
            setLoading(true);
            // Format date based on transaction type
            let date = formData.transaction_date;
            let formattedDate = formData.transaction_date;
            if (formData.transaction_type === 'monthly' && date.length === 7) {
                date += '-01';
            }
            
            const payload = { ...formData, transaction_date: date };
            editMode
                ? await CustomAxios.put(`business-operations-history/${selectedId}/`, payload)
                : await CustomAxios.post('business-operations-history/create/', payload);

            showToast('success', 'Success', editMode ? 'Updated successfully' : 'Created successfully');
            handleCloseModal();
            fetchHistory();
        } catch (error) {
            showToast('error', 'Error', error.response?.data?.error || 'Operation failed');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this history record?')) {
            return;
        }

        try {
            setLoading(true);
            await CustomAxios.delete(`business-operations-history/${id}/`);
            showToast('success', 'Success', 'History record deleted successfully');
            fetchHistory();
        } catch (error) {
            showToast('error', 'Error', error.response?.data?.error || 'Delete failed');
        } finally {
            setLoading(false);
        }
    };

    const showToast = (severity, summary, detail) => {
        if (toast.current) {
            toast.current.show({ severity, summary, detail, life: 3000 });
        }
    };
    console.log(filteredInventory)
    console.log(categories)
    return (
        <Box sx={{ p: 3 }}>
            <Toast ref={toast} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5">Business Operation History</Typography>
                <Box sx={{
                display: "flex",
                gap: { xs: "8px", md: "20px" },
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" },
                width: { xs: "100%", md: "auto" },
                mb: 3
            }}>
                {Array.isArray(selectedDate) &&
                    selectedDate[0] &&
                    dayjs(selectedDate[0]).isSame(dayjs(), 'day') && (
                        <Typography sx={{ fontWeight: 500 }}>
                            Today
                        </Typography>
                    )}

                <Stack sx={{ width: { xs: "100%", sm: "300px" } }}>
                    <Calendar
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.value)}
                        selectionMode="range"
                        readOnlyInput
                        hideOnRangeSelection
                        placeholder="Select Date or Range"
                        showIcon
                        dateFormat="dd-mm-yy"
                        style={{ width: '100%' }}
                    />
                </Stack>

                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handleOpenModal()}
                >
                    Add History Record
                </Button>
            </Box>
            </Box>

            <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', position: 'sticky', left: 0, zIndex: 10, minWidth: 200 }}>
                                Particulars
                            </TableCell>
                            {(() => {
                                // Get all unique dates from records
                                const dates = [...new Set(historyRecords.map(item => {
                                    const date = new Date(item.transaction_date);
                                    if (item.transaction_type === 'monthly') {
                                        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
                                    }
                                    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
                                }))].sort((a, b) => new Date(a) - new Date(b));

                                return dates.map((dateStr) => (
                                    <TableCell 
                                        key={dateStr} 
                                        align="right" 
                                        sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', minWidth: 120 }}
                                    >
                                        {dateStr}
                                    </TableCell>
                                ));
                            })()}
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', minWidth: 100 }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(() => {
                            // Group records by business operation, then by category
                            const grouped = historyRecords.reduce((acc, item) => {
                                const opName = item.business_operation_name;
                                const catName = item.business_category_name;
                                
                                if (!acc[opName]) {
                                    acc[opName] = {};
                                }
                                if (!acc[opName][catName]) {
                                    acc[opName][catName] = [];
                                }
                                acc[opName][catName].push(item);
                                return acc;
                            }, {});

                            // Get all unique dates
                            const allDates = [...new Set(historyRecords.map(item => {
                                const date = new Date(item.transaction_date);
                                return date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
                            }))].sort((a, b) => new Date(a) - new Date(b));

                            // Render grouped table
                            let serialNumber = 1;
                            return Object.keys(grouped).map((opName) => {
                                const categories = grouped[opName];
                                const categoryKeys = Object.keys(categories);
                                
                                return (
                                    <React.Fragment key={opName}>
                                        {/* Business Operation Subheader */}
                                        <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                                            <TableCell 
                                                colSpan={allDates.length + 2} 
                                                sx={{ 
                                                    fontWeight: 'bold', 
                                                    fontSize: '16px',
                                                    backgroundColor: '#e3f2fd',
                                                    borderBottom: '2px solid',
                                                    borderColor: '#90caf9'
                                                }}
                                            >
                                                {serialNumber++}. {opName}
                                            </TableCell>
                                        </TableRow>
                                        {/* Categories under this business operation */}
                                        {categoryKeys.map((catName) => {
                                            const records = categories[catName];
                                            // Create a map of date -> amount for this category
                                            const dateAmountMap = {};
                                            records.forEach(item => {
                                                const date = new Date(item.transaction_date);
                                                const dateStr = date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
                                                // If multiple records for same date, sum them
                                                dateAmountMap[dateStr] = (dateAmountMap[dateStr] || 0) + parseFloat(item.total_amount);
                                            });

                                            return (
                                                <TableRow key={catName}>
                                                    <TableCell sx={{ position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 5 }}>
                                                        {catName}
                                                    </TableCell>
                                                    {allDates.map((dateStr) => (
                                                        <TableCell key={dateStr} align="right">
                                                            {dateAmountMap[dateStr] ? dateAmountMap[dateStr].toFixed(2) : '-'}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell>
                                                        <IconButton 
                                                            size="small"
                                                            onClick={() => {
                                                                // Open modal with first record of this category for editing
                                                                if (records.length > 0) {
                                                                    handleOpenModal(records[0]);
                                                                }
                                                            }}
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton 
                                                            size="small"
                                                            onClick={() => {
                                                                // Delete all records for this category
                                                                if (window.confirm(`Delete all records for ${catName}?`)) {
                                                                    records.forEach(record => handleDelete(record.id));
                                                                }
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            });
                        })()}
                    </TableBody>
                </Table>
            </TableContainer>

            <Modal open={modalOpen} onClose={handleCloseModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '90vh',
                    overflow: 'auto'
                }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        {editMode ? 'Edit' : 'Add'} History Record
                    </Typography>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Business Category</InputLabel>
                        <Select
                            value={formData.business_category_id}
                            onChange={(e) => setFormData({ ...formData, business_category_id: e.target.value })}
                            label="Business Category"
                        >
                            {categories.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>
                                    {cat.category_name} ({cat.business_operation_name})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Hub</InputLabel>
                        <Select
                            value={formData.hub_id}
                            onChange={(e) => setFormData({ ...formData, hub_id: e.target.value})}
                            label="hub selection"
                        >
                            {filteredInventory.map((inv) => (
                                <MenuItem key={inv.value} value={inv.value}>
                                    {inv.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth
                        label="Total Amount"
                        name="total_amount"
                        type="number"
                        value={formData.total_amount}
                        onChange={(e) => setFormData({ ...formData, total_amount: e.target.value })}
                        sx={{ mb: 2 }}
                    />
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Transaction Type</InputLabel>
                        <Select
                            value={formData.transaction_type}
                            onChange={(e) => {
                                const newType = e.target.value;
                                let newDate = formData.transaction_date;
                                
                                // When switching types, adjust date format
                                if (newType === 'monthly' && newDate) {
                                    // Convert date to month format (YYYY-MM-DD -> YYYY-MM)
                                    newDate = newDate.substring(0, 7);
                                } else if (newType === 'daily' && newDate) {
                                    // If switching from monthly, set to first day of month
                                    if (newDate.length === 7) {
                                        newDate = newDate + '-01';
                                    }
                                } else if (newType === 'daily' && !newDate) {
                                    newDate = new Date().toISOString().split('T')[0];
                                } else if (newType === 'monthly' && !newDate) {
                                    newDate = new Date().toISOString().substring(0, 7);
                                }
                                
                                setFormData({ 
                                    ...formData, 
                                    transaction_type: newType,
                                    transaction_date: newDate
                                });
                            }}
                            label="Transaction Type"
                        >
                            <MenuItem value="daily">Daily</MenuItem>
                            <MenuItem value="monthly">Monthly</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth
                        label={formData.transaction_type === 'monthly' ? 'Transaction Month' : 'Transaction Date'}
                        name="transaction_date"
                        type={formData.transaction_type === 'monthly' ? 'month' : 'date'}
                        value={formData.transaction_date}
                        onChange={(e) => {
                            let value = e.target.value;
                            // For monthly, ensure we only have YYYY-MM format
                            if (formData.transaction_type === 'monthly') {
                                value = value.substring(0, 7);
                            }
                            setFormData({ ...formData, transaction_date: value });
                        }}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                        helperText={formData.transaction_type === 'monthly' ? 'Select month (year and month only)' : 'Select specific date'}
                    />
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                        <Button onClick={handleCloseModal}>Cancel</Button>
                        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                            {editMode ? 'Update' : 'Create'}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
}

